import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Edit: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[24px] h-[24]', className)}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.9343 4.93432C14.6147 4.25386 15.5376 3.87158 16.5 3.87158C17.4623 3.87158 18.3852 4.25386 19.0656 4.93432C19.7461 5.61479 20.1284 6.53769 20.1284 7.50001C20.1284 8.46233 19.7461 9.38523 19.0656 10.0657L18.0669 11.0644C18.0665 11.0648 18.0661 11.0653 18.0656 11.0657C18.0652 11.0661 18.0648 11.0666 18.0643 11.067L8.56564 20.5657C8.41561 20.7157 8.21212 20.8 7.99995 20.8H3.99995C3.55812 20.8 3.19995 20.4418 3.19995 20V16C3.19995 15.7878 3.28424 15.5844 3.43427 15.4343L13.9343 4.93432ZM13.4999 7.63138L4.79995 16.3314V19.2H7.66858L16.3686 10.5L13.4999 7.63138ZM17.5 9.36864L14.6313 6.50001L15.0656 6.06569C15.446 5.68529 15.962 5.47158 16.5 5.47158C17.0379 5.47158 17.5539 5.68529 17.9343 6.06569C18.3147 6.4461 18.5284 6.96204 18.5284 7.50001C18.5284 8.03798 18.3147 8.55392 17.9343 8.93432L17.5 9.36864Z"
      fill="currentColor"
    />
  </svg>
);

export default Edit;
